import {loginByUsername, loginBySocial, registerByUsername, logout, getUserInfo,updateUserInfo} from '@/api/admin/login'
import { setToken, removeToken, setRefreshToken, removeRefreshToken } from '@/utils/auth'
import { setStore, getStore } from '@/utils/store'
import { encryption } from '@/utils/util'

const user = {
  state: {
    userInfo: getStore({
      name: 'userInfo'
    }) || {},
    permissions: getStore({
      name: 'permissions'
    }) || {},
    roles: getStore({
      name: 'roles'
    }) || [],
    menu: getStore({
      name: 'menu'
    }) || [],
    isInitMenu: getStore({
      name: 'isInitMenu'
    }) || false,
    token: getStore({
      name: 'token'
    }) || '',
    refresh_token: getStore({
      name: 'refresh_token'
    }) || '',
    tenantCode: getStore({
      name: 'tenantCode'
    }) || '',
    sysConfig: getStore({
      name: 'sys_config'
    }) || ''
  },
  actions: {
    LoginByUsername ({ commit, state, dispatch }, userInfo) {
      return new Promise((resolve, reject) => {
        const user = encryption({
          data: userInfo,
          key: '1234567887654321',
          param: ['credential']
        })
        const {credential,telephone:identifier,...params} = user
        loginByUsername( {...params,identifier}).then(response => {
          const rdata = response.data
          const {code, data} = rdata
          if (code === 200) {
            setToken(data.access_token)
            setRefreshToken(data.access_token)
            commit('SET_TOKEN', data.access_token)
            commit('SET_REFRESH_TOKEN', data.access_token)
            commit('SET_TENANT_CODE', data.tenantCode);
            resolve()
          }else{
            this.$loading().close();
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginBySocial ({ commit, state, dispatch }, userInfo) {
      return new Promise((resolve, reject) => {
        const user = encryption({
          data: userInfo,
          key: '1234567887654321',
          param: ['credential']
        })
        loginBySocial(user.tenantCode, user.phone, user.code).then(response => {
          const rdata = response.data
          const {code, data} = rdata
          if (code === 200) {
            setToken(data.access_token)
            setRefreshToken(data.access_token)
            commit('SET_TOKEN', data.access_token)
            commit('SET_REFRESH_TOKEN', data.access_token)
            commit('SET_TENANT_CODE', data.tenantCode)
            resolve()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    RegisterByUsername ({ commit, state, dispatch }, userInfo) {
      console.log(userInfo,"userInfo")
      return new Promise((resolve, reject) => {
        const user = encryption({
          data: userInfo,
          key: '1234567887654321',
          param: ['credential']
        })
        console.log('user',user)
        const {credential,...params} = user
        registerByUsername(params).then(response => {
          const rdata = response.data
          const {code, data} = rdata
          if (code === 200) {
            setToken(data.access_token)
            setRefreshToken(data.access_token)
            commit('SET_TOKEN', data.access_token)
            commit('SET_REFRESH_TOKEN', data.access_token)
            commit('SET_TENANT_CODE', data.tenantCode)
            resolve()
          }else{
            this.$loading().close();
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUserInfo ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          const data = response.data && response.data.data;
          // commit('SET_ROLES', data.roles)
          commit('SET_USER_INFO', data)
          // commit('SET_PERMISSIONS', data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateUserInfo({commit,state,dispatch},userInfo){
      return new Promise((resolve,reject)=>{
        updateUserInfo(userInfo).then(response=>{
         dispatch('GetUserInfo')
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token, state.refresh_token).then(() => {
          commit('SET_PERMISSIONS', [])
          commit('SET_USER_INFO', {})
          commit('SET_TOKEN', '')
          commit('SET_REFRESH_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_SYS_CONFIG', {})
          commit('SET_TENANT_CODE', {})
          removeToken()
          resolve()
        }).catch(error => {
          console.error(error)
        })
      })
    },
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_PERMISSIONS', [])
        commit('SET_USER_INFO', {})
        commit('SET_TOKEN', '')
        commit('SET_REFRESH_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_SYS_CONFIG', {})
        commit('SET_TENANT_CODE', {})
        removeToken()
        removeRefreshToken()
        resolve()
      })
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      setStore({
        name: 'token',
        content: state.token
      })
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      setStore({
        name: 'userInfo',
        content: state.userInfo
      })
    },
    SET_REFRESH_TOKEN: (state, rfToken) => {
      state.refresh_token = rfToken
      setStore({
        name: 'refresh_token',
        content: state.refresh_token
      })
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
      setStore({
        name: 'roles',
        content: state.roles
      })
    },
    SET_PERMISSIONS: (state, permissions) => {
      const list = {}
      for (let i = 0; i < permissions.length; i++) {
        list[permissions[i]] = true
      }
      state.permissions = list
      setStore({
        name: 'permissions',
        content: state.permissions
      })
    },
    SET_TENANT_CODE: (state, tenantCode) => {
      state.tenantCode = tenantCode
      setStore({
        name: 'tenantCode',
        content: state.tenantCode
      })
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js